import api from "../utils/api";

/**
 * Fee Management API Service
 */

// 📊 Dashboard statistics
export const getDashboardStats = (params = {}) => {
  return api.get("/api/fees/dashboard-stats", { params });
};

// 📋 Students fee overview list (with class dropdown, search, pagination, status)
export const getStudentsFeeList = (params = {}) => {
  return api.get("/api/fees/students", { params });
};

// 🔍 Single student fee details, monthly records, and transactions
export const getStudentFeeDetails = (studentId) => {
  return api.get(`/api/fees/student/${studentId}`);
};

// ⚙️ Configure student admission and monthly recurring fee structure
export const configureStudentFee = (studentId, data) => {
  return api.post(`/api/fees/student/${studentId}/configure`, data);
};

// 💳 Record payment for admission fee or monthly fee obligation
export const recordPayment = (studentId, data) => {
  return api.post(`/api/fees/student/${studentId}/record-payment`, data);
};

// 🧾 Fetch single payment receipt by receipt number
export const getReceipt = (receiptNumber) => {
  return api.get(`/api/fees/receipt/${receiptNumber}`);
};

// 📑 Comprehensive fee reports (10 report types)
export const getFeeReports = (params = {}) => {
  return api.get("/api/fees/reports", { params });
};

// 🏫 Class-level fee structure APIs
export const getClassFeeStructure = (classId) => {
  return api.get(`/api/fees/class/${classId}`);
};

export const getAllClassFeeStructures = () => {
  return api.get("/api/fees/classes/overview");
};

export const configureClassFee = (classId, data) => {
  return api.post(`/api/fees/class/${classId}/configure`, data);
};

// 📅 Available academic sessions list
export const getAvailableSessions = () => {
  return api.get("/api/fees/sessions");
};

// 📈 Class Fee Comparison & Irregular Defaulters Analytics
export const getFeeAnalytics = (params = {}) => {
  return api.get("/api/fees/analytics", { params });
};

// ⚖️ Debit & Credit Fee Adjustments (ID Card, Badge, Concessions, etc.)
export const postFeeAdjustment = (studentId, data) => {
  return api.post(`/api/fees/student/${studentId}/adjustment`, data);
};

export const getStudentAdjustments = (studentId) => {
  return api.get(`/api/fees/student/${studentId}/adjustments`);
};

export const payDebitAdjustment = (adjustmentId, data) => {
  return api.post(`/api/fees/adjustment/${adjustmentId}/pay`, data);
};

export const deleteFeeAdjustment = (adjustmentId) => {
  return api.delete(`/api/fees/adjustment/${adjustmentId}`);
};

// ⏰ Manually trigger daily fee calculation & reconciliation
export const reconcileDailyFees = () => {
  return api.post("/api/fees/cron/reconcile-daily");
};

// 🎓 Smart Promotion Financial Preview
export const previewStudentPromotion = (data) => {
  return api.post("/api/users/promote/preview", data);
};


